import AltDateWidget from './AltDateWidget';
import AltDateTimeWidget from './AltDateTimeWidget';
import CheckboxWidget from './CheckboxWidget';
import CheckboxesWidget from './CheckboxesWidget';
import ColorWidget from './ColorWidget';
import DateWidget from './DateWidget';
import DateTimeWidget from './DateTimeWidget';
import EmailWidget from './EmailWidget';
import FileWidget from './FileWidget';
import HiddenWidget from './HiddenWidget';
import PasswordWidget from './PasswordWidget';
import RadioWidget from './RadioWidget';
import RangeWidget from './RangeWidget';
import SelectWidget from './SelectWidget';
import TextareaWidget from './TextareaWidget';
import TextWidget from './TextWidget';
import TimeWidget from './TimeWidget';
import URLWidget from './URLWidget';
import UpDownWidget from './UpDownWidget';
function widgets() {
    return {
        AltDateWidget,
        AltDateTimeWidget,
        CheckboxWidget,
        CheckboxesWidget,
        ColorWidget,
        DateWidget,
        DateTimeWidget,
        EmailWidget,
        FileWidget,
        HiddenWidget,
        PasswordWidget,
        RadioWidget,
        RangeWidget,
        SelectWidget,
        TextWidget,
        TextareaWidget,
        TimeWidget,
        UpDownWidget,
        URLWidget,
    };
}
export default widgets;
//# sourceMappingURL=index.js.map